/* eslint-disable no-bitwise */
/* eslint-disable no-extend-native */
/**
 * @module AppHelpers
 */
/* istanbul ignore next */
String.prototype.hashCode = () => {
  let hash = 0;
  let i;
  let chr;
  if (this.length === 0) {
    return hash.toString();
  }
  for (i = 0; i < this.length; i += 1) {
    chr = this.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash).toString();
};

/**
 * Helper function for articles adding the alphabetical sorting folder to the original path.
 *
 * @param {string} path - The article path without alphabetical folder.
 *
 * @returns {strng}The adjusted path including the alphabetical folder.
 */
export const getFullArticlePath = (path) => {
  if (!path) {
    return path;
  }
  let originalPath = path;
  if (!originalPath.startsWith('/')) {
    originalPath = `/${originalPath}`;
  }
  if (originalPath.length >= 2) {
    const firstChar = originalPath.charAt(1).toLowerCase();
    return `/${firstChar}${originalPath}`;
  }
  return originalPath;
};

/**
 * Helper function for articles removing the alphabetical sorting folder from the original path.
 *
 * @param {string} path - The article path with alphabetical folder.
 *
 * @returns {string} The adjusted path excluding the alphabetical folder.
 */
export const removeFolderPath = (path) => {
  if (!path) {
    return path;
  }
  let originalPath = path;
  if (!originalPath.startsWith('/')) {
    originalPath = `/${originalPath}`;
  }
  const parts = originalPath.split('/');
  if (parts.length >= 3 && parts[1].length === 1) {
    const joined = parts.slice(2).join('/');
    return `/${joined}`;
  }
  return originalPath;
};
